import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import ConstructionsList from '../components/constructions/ConstructionsList'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function ConstructionsPage({ building, isSecurityUser }) {
  const history = useHistory()

  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <ConstructionsList
          building={isSecurityUser ? building : null}
          redirectTo={history.location.pathname}
        />
      </Container>
    </main>
  )
}
